module.exports = __webpack_public_path__ + "img/T.032e98e0.png";